import { render } from "./ServiceFieldModal.vue?vue&type=template&id=72334e1d&scoped=true"
import script from "./ServiceFieldModal.vue?vue&type=script&lang=ts"
export * from "./ServiceFieldModal.vue?vue&type=script&lang=ts"

import "./ServiceFieldModal.vue?vue&type=style&index=0&id=72334e1d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-72334e1d"

export default script